module.exports = __webpack_public_path__ + "img/icon_work_proposal_icon_15.7801d2fa.png";